export default "__VITE_ASSET__DD57AFzs__"